import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", {
    class: "modal-title fw-bold",
    id: "exampleModalLabel"
  }, " Create Segmentation "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close bg-info text-light rounded-pill px-3 opacity-100",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_4 = { class: "modal-body p-3 px-4 row d-flex align-self-stretch" }
const _hoisted_5 = { class: "col-12 col-lg-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus-circle",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_7 = { class: "col-12 col-lg-5" }
const _hoisted_8 = { class: "h-100 w-100 border border-secondary border-opacity-50 rounded p-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "text-primary fw-normal mb-3" }, "Options:", -1)
const _hoisted_10 = { class: "bg-light border border-primary rounded rounded-pill px-3 py-1 align-items-center d-flex justify-content-between" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true"
}, null, -1)

import { Modal } from "bootstrap";
import { ref, onMounted } from "vue";
import BaseInputUnderline from "@/components/base-components/BaseInputUnderline.vue";


const __default__ = {
  name: "CreateSegmentationModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["save-segmentation"],
  setup(__props, { emit }) {

const modal = ref<Modal>();
const optionToAdd = ref("");
const isEditing = ref(false);


const form = ref({
  id: "",
  label: "",
  question: "",
  options: [] as string[],
});

const save = () => {
  if (
    form.value.label !== "" &&
    form.value.question !== "" &&
    form.value.options.length !== 0
  ) {
    if (!isEditing.value) {
      form.value.id = "id" + new Date().getTime();
    }
    let newForm = { ...form.value };
    emit("save-segmentation", newForm);
    let m = Modal.getInstance(modal.value);
    m?.hide();
  }
};

const addOption = () => {
  if (
    optionToAdd.value !== "" &&
    !form.value.options.includes(optionToAdd.value)
  ) {
    form.value.options.push(optionToAdd.value);
    optionToAdd.value = "";
  }
};

onMounted(() => {
  form.value = {
    id: "",
    label: "",
    question: "",
    options: [],
  };
  optionToAdd.value = "";
  modal.value?.addEventListener(
    "show.bs.modal",
    (event: { relatedTarget: { getAttribute: (arg0: string) => string } }) => {
      if (event.relatedTarget.getAttribute("data-bs-create-edit") === "edit") {
        let segmentation = JSON.parse(
          event.relatedTarget.getAttribute("data-bs-segmentation")
        );
        form.value.id = segmentation.id;
        form.value.label = segmentation.label;
        form.value.question = segmentation.question;
        form.value.options = segmentation.options;
        isEditing.value = true;
      } else {
        form.value.id = "";
        form.value.label = "";
        form.value.question = "";
        form.value.options = [];
      }
    }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modal",
    ref: modal,
    class: "modal fade",
    id: "createSegmentationModal",
    tabindex: "-1",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true",
    "data-bs-touch": "false",
    "data-bs-interval": "false"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(save, ["prevent"]),
        class: "modal-content bg-light rounded-card px-3 px-sm-4 py-3"
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(BaseInputUnderline, {
              value: form.value.label,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.label) = $event)),
              name: "create-segmentation-label",
              type: "text",
              id: "create-segmentation-label",
              "aria-placeholder": "What do you think?",
              label: "Segmentation Label:",
              required: ""
            }, null, 8, ["value"]),
            _createElementVNode("div", null, [
              _createVNode(BaseInputUnderline, {
                value: form.value.question,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.question) = $event)),
                name: "segmentation-question",
                type: "text",
                id: "question-segmentation-question",
                "aria-placeholder": "What do you think?",
                placeholder: "What do you think?",
                label: "Write segmentation question:",
                class: "pt-4"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(BaseInputUnderline, {
                value: optionToAdd.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((optionToAdd).value = $event)),
                name: "create-segmentation-option",
                type: "text",
                id: "create-segmentation-option",
                "aria-placeholder": "What do you think?",
                label: "Segmentation Option:",
                required: "",
                class: "pt-4"
              }, null, 8, ["value"]),
              _createElementVNode("div", { class: "text-end mb-3" }, [
                _createElementVNode("button", {
                  onClick: addOption,
                  type: "button",
                  class: "btn btn-primary text-light btn-sm rounded-pill fw-lighter"
                }, [
                  _createTextVNode(" Add Option "),
                  _hoisted_6
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.options, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  class: "my-1"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, _toDisplayString(option), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("i", {
                        onClick: ($event: any) => (
                        form.value.options = form.value.options.filter((e) => e !== option)
                      ),
                        class: "fa fa-close ms-2 text-primary cursor-pointer",
                        "aria-hidden": "true"
                      }, null, 8, _hoisted_12)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("button", {
            onClick: save,
            class: "btn btn-primary text-light rounded-pill py-1"
          }, [
            _createTextVNode(" Save "),
            _hoisted_13
          ])
        ])
      ], 40, _hoisted_2)
    ])
  ], 512))
}
}

})